// extracted by css-extract-rspack-plugin
export default {"header":"n7zdsPmxXNYJQduH","logo":"zaeaBXr2IYgNulub","title":"xMiYM7FIU84L8OOs"};